<template>
  <div class="c_title_v">
    <div class="c_title">
      <span class="t_es">{{ titleEn }} </span>
      <span :style="{ color: zhColor }" class="t_zh">{{ titleZh }}</span>
    </div>
    <p v-if="showMore" class="more" @click="handleMore">更多>></p>
  </div>
</template>

<script>
export default {
  props: {
    titleEn: String,
    titleZh: String,
    showMore: {
      type: Boolean,
      default: false,
    },
    zhColor: {
      type: String,
      default: "#406cdd",
    },
  },
  methods: {
    handleMore() {
      this.$emit("more");
    },
  },
};
</script>

<style lang="scss" scoped>
$themeColor: #406cdd;
.c_title_v {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px 0 0 0;
}

.c_title {
  height: 44px;
  position: relative;

  .t_es {
    font-size: 36px;
    font-weight: bold;
    color: #444444;
    opacity: 0.1;
  }

  .t_zh {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: $themeColor;
    position: absolute;
    left: 0;
    bottom: 0;
  }
}

.more {
  font-size: 16px;
  color: #406cdd;
  cursor: pointer;
}
</style>
